__turbopack_context__.v({
  "UiButton": "moma-ps1-i-love-you-module__2H9vkq__UiButton",
  "UiButton__icon": "moma-ps1-i-love-you-module__2H9vkq__UiButton__icon",
  "UiMain": "moma-ps1-i-love-you-module__2H9vkq__UiMain",
  "UiSplide__arrows": "moma-ps1-i-love-you-module__2H9vkq__UiSplide__arrows",
  "UiSplide__arrows__button": "moma-ps1-i-love-you-module__2H9vkq__UiSplide__arrows__button",
  "UiSplide__track": "moma-ps1-i-love-you-module__2H9vkq__UiSplide__track",
  "UiSplide__track__slide": "moma-ps1-i-love-you-module__2H9vkq__UiSplide__track__slide",
  "UiText__body": "moma-ps1-i-love-you-module__2H9vkq__UiText__body",
  "UiText__lg": "moma-ps1-i-love-you-module__2H9vkq__UiText__lg",
  "UiTimeline": "moma-ps1-i-love-you-module__2H9vkq__UiTimeline",
  "UiTimeline__grid": "moma-ps1-i-love-you-module__2H9vkq__UiTimeline__grid",
  "UiTimeline__grid__image": "moma-ps1-i-love-you-module__2H9vkq__UiTimeline__grid__image",
  "UiTimeline__grid__item": "moma-ps1-i-love-you-module__2H9vkq__UiTimeline__grid__item",
  "UiTimeline__grid__text": "moma-ps1-i-love-you-module__2H9vkq__UiTimeline__grid__text",
  "UiTimeline__grid__title": "moma-ps1-i-love-you-module__2H9vkq__UiTimeline__grid__title",
  "UiTimeline__ul": "moma-ps1-i-love-you-module__2H9vkq__UiTimeline__ul",
  "UiTimeline__ul__li": "moma-ps1-i-love-you-module__2H9vkq__UiTimeline__ul__li",
  "UiTimeline__ul__li__scroll": "moma-ps1-i-love-you-module__2H9vkq__UiTimeline__ul__li__scroll",
  "UiTimeline__ul__li__scroll__span": "moma-ps1-i-love-you-module__2H9vkq__UiTimeline__ul__li__scroll__span",
});
